import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TblTheoryExamSet } from '../../../Interfaces/DataBase';
import TblTheoryExam from '../../../Interfaces/DataBase/TblTheoryExam';

interface initialExamSetProps {
  FirstFormData: TblTheoryExamSet;
  SecondFormData: TblTheoryExam[];
}

export const initialExamSet: initialExamSetProps = {
  FirstFormData: {
    DefaultExamInstructions: '',
    TheorySegment: '',
    Duration: 0,
    examEndDate: '',
    examStartDate: '',
    ExamTypeInternelServiceId: '',
    Hours: 0,
    Minutes: 0,
    TheoryExamSetName: '',
  },
  SecondFormData: [],
};

const examSetSlice = createSlice({
  name: 'examSet',
  initialState: initialExamSet,
  reducers: {
    setExamSetFirstForm: (state, action: PayloadAction<TblTheoryExamSet>) => {
      state.FirstFormData = action.payload;
    },
    setExamSetSecondForm: (state, action: PayloadAction<TblTheoryExam[]>) => {
      state.SecondFormData = action.payload;
    },
    setClearExamSet: (state) => {
      state = {
        FirstFormData: {
          DefaultExamInstructions: '',
          TheorySegment: '',
          Duration: 0,
          examEndDate: '',
          examStartDate: '',
          ExamTypeInternelServiceId: '',
          Hours: 0,
          Minutes: 0,
          TheoryExamSetName: '',
        },
        SecondFormData: [],
      };
    },
  },
});

export const { setExamSetFirstForm, setExamSetSecondForm, setClearExamSet } =
  examSetSlice.actions;

export default examSetSlice.reducer;
